import { MobileNavMenu } from './MobileNavMenu'
import styles from './NavigationBar.module.css'
import { TopNavMenu } from './TopNavMenu'
import { UserMenu } from './UserMenu'

export function NavigationBar() {
  return (
    <header className="mb-5 px-5 py-3 max-w-6xl bg-white border-noround shadow-1 border-none flex justify-content-center">
      <div className="max-w-app flex justify-content-between max-w-screen-xl flex-grow-1 align-items-center">
        <div className="flex align-items-center gap-4">
          <img src="/logo.svg" alt="App Logo" className="w-auto w-8rem" />
          <div className={styles.desktopNav}>
            <TopNavMenu />
          </div>
        </div>
        <div className={styles.desktopNav}>
          <UserMenu />
        </div>
        <div className={styles.mobileNav}>
          <MobileNavMenu />
        </div>
      </div>
    </header>
  )
}
